import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tc-icons-close",
  "use": "tc-icons-close-usage",
  "viewBox": "160 160 192 192",
  "content": "<symbol viewBox=\"160 160 192 192\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"tc-icons-close\">\n <path d=\"M340.2 160 L255.8 244.3 171.8 160.4 160 172.2 244 256 160 339.9 171.8 351.6 255.8 267.8 340.2 352 352 340.3 267.6 256 352 171.8 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol